module.exports = __webpack_public_path__ + "static/media/gb.49f4b04b.svg";